import React, { useState } from "react"
import { Sidebar, Menu } from "react-pro-sidebar"
import { createUseStyles } from "react-jss"
import { NAV } from "../../util/StaticData"
import { SidebarMenuRecursive } from "./SidebarMenuRecursive"

const useStyles = createUseStyles({
  sidebarContainer: {
    display: "flex",
    background: "#F4F4F4",
  },
  sidebarRoot: {
    borderRadius: "50px",
  },
  menuRoot: {
    marginTop: "16px",
  },
})

const CustomSidebar = () => {
  const [isHovered, setIsHovered] = useState(false)
  const classes = useStyles()

  const handleMouseEnter = () => {
    setIsHovered(true)
  }

  const handleMouseLeave = () => {
    setIsHovered(false)
  }

  return (
    <div className={classes.sidebarContainer}>
      <Sidebar
        backgroundColor="white"
        collapsed={!isHovered}
        collapsedWidth={"60px"}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        rootStyles={{
          borderRadius: "50px",
        }}
      >
        <Menu
          rootStyles={{
            marginTop: "16px",
          }}
        >
          {Object.keys(NAV).map((key) => (
            <SidebarMenuRecursive key={NAV[key].key} item={NAV[key]} />
          ))}
        </Menu>
      </Sidebar>
    </div>
  )
}

export default CustomSidebar
